<template>
    <div class="page">
        <el-scrollbar class="Yscrollbar" style="height:calc(100% - 8vh);">
            <LabelContent :title="$t('menu.person')" />
            <el-form label-width="100px" class="u-form" size="small">
                <el-form-item :label="$t('base.name')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.phone')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userPhone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.email')">
                    <el-input :placeholder="$t('base.PleaseEnter')" v-model="userInfo.userEmail"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="long" @click="updateUserInfo" type="primary" size="small">{{$t('menu.ChangeInfo')}}</el-button>
                </el-form-item>
            </el-form>
            <LabelContent :title="$t('base.changePassword')" />
            <el-form label-width="100px" class="u-form" size="small">
                <el-form-item :label="$t('base.oldPassword')">
                    <el-input :type="oldPwdShow ? 'password' : 'text'" v-model="opwd" :placeholder="$t('base.PleaseEnter')">
                        <i slot="suffix" class="iconfont" :class="oldPwdShow ? 'u-bukejian' : 'u-kejian'" @click="oldPwdShow = !oldPwdShow" />
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('base.newPassword')">
                    <el-input :type="newPwdShow ? 'password' : 'text'" v-model="npwd" :placeholder="$t('base.PleaseEnter')">
                        <i slot="suffix" class="iconfont" :class="newPwdShow ? 'u-bukejian' : 'u-kejian'" @click="newPwdShow = !newPwdShow" />
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="updatePwd" type="primary">{{$t('base.changePassword')}}</el-button>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <!-- <div class="bottomBtnBox">
            <el-button class="long" @click="updateUserInfo" type="primary" size="small">修改信息</el-button>
        </div> -->
    </div>
</template>
<script>
import md5 from 'js-md5'
import { editUser, editUserPassword } from '../../libs/api'
export default {
    name: 'Factory',
    data() {
        return {
            //密码不可见控制
            oldPwdShow: true,
            newPwdShow: true,
            userInfo: {},
            opwd: '',
            npwd: ''
        }
    },
    mounted() {
        // this.userInfo = this.$store.state.userInfo
        this.getUserInfo()
    },
    methods: {
        getUserInfo() {
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            let options = {
                url: this.$api.findUserById,
                method: 'GET',
                params: {userId:userInfo.userId}
            }
            this.$http.request(options).then(resp => {
                    if (resp.status == 100) {
                        this.userInfo = resp.data
                        delete this.userInfo.userPasswd
                    }
                })
                .catch(() => {})
        },
        test() {},
        updatePwd() {
            if (this.opwd && this.npwd) {
                if (this.npwd.length >= 6) {
                    this.$http
                        .request({
                            url: this.$api.editUserPassword,
                            method: 'POST',
                            showLoading: true,
                            params: {
                                oldPassWord: md5(this.opwd),
                                newPassWord: this.npwd
                            }
                        })
                        .then(resp => {
                            if (resp.status == 100) {
                                this.$message.success(this.$t('base.SuccessfullyUpdated'))
                                this.opwd = ''
                                this.npwd = ''
                                this.getUserInfo()
                            } else {
                                this.$message.error(resp.message)
                            }
                        })
                } else {
                    this.$message.error(this.$t('menu.Password'))
                }
            } else {
                this.$message.error(this.$t('menu.empty'))
            }
        },
        updateUserInfo() {
            if(this.userInfo.userName == null || this.userInfo.userName == '' || this.userInfo.userName == undefined){
                this.$message.error(this.$t('User.name'))
                return
            }
            let options = {
                method: 'POST',
                data: this.userInfo,
                url: this.$api.editUserInfo
            }
            this.$http.request(options).then(response => {
                    if (response.status != 100) {
                        this.$message.error(response.message)
                    }
                    this.getUserInfo()
                    this.$message.success(this.$t('base.SuccessfullyUpdated'))
                })
                .catch(err => {
                    this.$message.error(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped></style>
